import { Linkedin, Mail } from "lucide-react"
import { XIcon } from "./XIcon"

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    empresa: [
      { label: "Sobre Nosotros", href: "https://aitomata.app" },
      { label: "Contacto", href: "https://aitomata.app" },
    ],
    productos: [
      { label: "Revvly", href: "https://aitomata.app" },
      { label: "Nevozio", href: "https://aitomata.app" },
      { label: "Rommu", href: "https://aitomata.app" },
      { label: "Simplecita", href: "https://aitomata.app" },
    ],
    legal: [
      { label: "Privacidad", href: "https://aitomata.app" },
      { label: "Términos de Servicio", href: "https://aitomata.app" },
      { label: "Política de Cookies", href: "https://aitomata.app" },
    ],
  };

  const socialLinks = [
    {
      icon: Linkedin,
      label: "LinkedIn",
      href: "https://linkedin.com/company/aitomata",
    },
    {
      icon: XIcon,
      label: "X",
      href: "https://x.com/aitomata",
    },
    {
      icon: Mail,
      label: "Email",
      href: "mailto:contacto@aitomata.app",
    },
  ];

  return (
    <footer
      className="relative text-white overflow-hidden"
      style={{
        backgroundImage: "url(/hero-bg.jpeg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Background Blur Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backdropFilter: "blur(6px)",
          zIndex: 0,
        }}
      ></div>

      {/* Background Gradient Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(to bottom right, rgba(15, 23, 42, 0.9), rgba(30, 58, 138, 0.85), rgba(15, 23, 42, 0.9))",
          zIndex: 1,
        }}
      ></div>

      {/* Main Footer Content */}
      <div className="relative z-20 container mx-auto max-w-7xl px-4 py-16">
        {/* Logo and Links Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-12 pb-12 border-b border-white/10">
          {/* Logo and Description - Left */}
          <div>
            <a
              href="https://aitomata.app"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 mb-4 hover:opacity-80 transition-opacity"
            >
              <img src="/logo_only.png" alt="Aitomata Logo" className="h-10 w-10 object-contain" />
              <span className="text-xl font-bold" style={{ fontFamily: "Drupadi" }}>Aitomata</span>
            </a>
            <p className="text-white/80 leading-relaxed text-sm">
              Transformamos ideas en soluciones digitales innovadoras que potencian
              el crecimiento de tu negocio.
            </p>
          </div>

          {/* Links Sections - Right */}
          <div className="lg:col-span-2 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {/* Empresa Links */}
            <div>
              <h4 className="font-semibold mb-4">Empresa</h4>
              <ul className="space-y-2">
                {footerLinks.empresa.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Productos Links */}
            <div>
              <h4 className="font-semibold mb-4">Productos</h4>
              <ul className="space-y-2">
                {footerLinks.productos.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal Links */}
            <div>
              <h4 className="font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                {footerLinks.legal.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Copyright */}
          <p className="text-white/70 text-sm">
            &copy; {currentYear} Aitomata. Todos los derechos reservados.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => {
              const IconComponent = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors"
                >
                  <IconComponent className="w-5 h-5" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
}
